var _path, _rect, _rect2, _path2, _rect3, _rect4, _path3, _rect5, _rect6, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _rect7, _rect8, _rect9, _rect10, _rect11, _path12, _path13, _rect12, _path14, _rect13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDriver(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    id: "driver",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M310 231v-10c23.5 0 34-15 34-29.9 0-14.4-24.8-16.1-25-16.1v-10c6.9 0 35 4.6 35 26.1 0 10.7-4.1 20.6-11.4 27.8C334.5 226.8 323.3 231 310 231zM138 231c-13.3 0-24.5-4.2-32.6-12.1-7.4-7.2-11.4-17.1-11.4-27.8 0-21.5 28.1-26.1 35-26.1v10c-.3 0-25 1.7-25 16.1 0 14.9 10.5 29.9 34 29.9V231z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31.6,
    height: 10,
    x: 106.8,
    y: 193.3,
    transform: "rotate(45.547 122.573 198.295)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 31.6,
    x: 320.4,
    y: 182.5,
    transform: "rotate(44.449 325.426 198.282)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M160.5,161.3l-5.1-8.6c5.2-3.1,13.6-6.7,24.5-6.7c0.1,0,0.2,0,0.3,0c10.8,0.1,19.1,3.7,24.3,6.7l-5.1,8.6c-4.1-2.4-10.7-5.3-19.2-5.3c-0.1,0-0.2,0-0.2,0C171.4,156,164.7,158.9,160.5,161.3z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 18,
    x: 172,
    y: 181
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 18,
    x: 178,
    y: 181
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M196.3 191.5c-1-.4-2-.9-3.2-1.5-3.1-1.7-7.4-4-12.9-4 0 0-.1 0-.1 0-5.2 0-10.5 1.8-15.2 5.1l-5.8-8.2c6.4-4.5 13.6-6.9 20.8-6.9.1 0 .1 0 .2 0 8.1 0 14.1 3.2 17.7 5.1.7.4 1.6.8 1.9.9L196.3 191.5zM287.5 161.3c-4.2-2.4-11-5.4-19.7-5.3-8.6 0-15.2 2.9-19.2 5.3l-5.1-8.6c5.1-3 13.5-6.6 24.3-6.7 11-.1 19.6 3.6 24.8 6.7L287.5 161.3z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 18,
    x: 266,
    y: 181
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 18,
    x: 260,
    y: 181
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M251.7 191.5l-3.4-9.4c.3-.1 1.2-.6 1.9-.9 3.6-1.9 9.6-5.1 17.7-5.1.1 0 .1 0 .2 0 7.3.1 14.5 2.4 20.8 6.9l-5.8 8.2c-4.7-3.3-9.9-5.1-15.2-5.1-5.6-.1-9.9 2.3-13.1 4C253.7 190.6 252.7 191.1 251.7 191.5zM339 133c-1.2 0-2.3-.4-3.3-1.2-.3-.3-35.4-29.3-111.7-29.3s-111.4 29-111.8 29.3c-1.5 1.3-3.6 1.5-5.3.7-1.8-.8-2.9-2.6-2.9-4.5V99.9c-8.1-3.6-28-14.7-28-35.4 0-13.6 16.7-29.5 44.8-42.6C138.2 13.7 174.9 0 224 0s85.8 13.7 103.2 21.9c28 13.1 44.8 29 44.8 42.6 0 20.7-19.9 31.7-28 35.4V128c0 2-1.1 3.7-2.9 4.5C340.4 132.9 339.7 133 339 133zM224 92.5c59.7 0 95.1 16.8 110 25.9V96.5c0-2.1 1.3-4 3.3-4.7.2-.1 24.7-9 24.7-27.3 0-7.4-12.2-21-39-33.5-16.7-7.8-51.9-21-99-21s-82.3 13.1-99 21C98.2 43.5 86 57.1 86 64.5c0 15.2 16.7 23.9 22.6 26.4C119.3 84.9 166.9 60 224 60c39.3 0 74.6 12 97.3 22.1l-4.1 9.1C295.4 81.5 261.5 70 224 70c-53.4 0-99.2 23.4-110 29.4v19C128.9 109.3 164.3 92.5 224 92.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M224,143c-79,0-102-20.5-102.9-21.3l6.8-7.3c0.2,0.1,21.9,18.7,96.1,18.7c74,0,95.9-18.5,96.1-18.7l6.8,7.3C326,122.5,303,143,224,143z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M129 175c-1 0-2-.3-2.8-.9-.9-.6-22.2-15.3-22.2-46.1h10c0 17 7.8 28.1 13.1 33.7l14.8-35.1 9.2 3.9-17.5 41.5c-.6 1.4-1.7 2.4-3.2 2.9C130 174.9 129.5 175 129 175zM319 175c-.5 0-1-.1-1.4-.2-1.4-.4-2.6-1.5-3.2-2.9l-17.5-41.5 9.2-3.9 14.8 35.1c5.3-5.5 13.1-16.6 13.1-33.7h10c0 30.8-21.3 45.5-22.2 46.1C321 174.7 320 175 319 175zM254 381c-1.3 0-2.5-.5-3.4-1.3L224 354.8l-26.6 24.8c-1.2 1.1-2.9 1.6-4.5 1.2-1.6-.4-2.9-1.5-3.6-3l-17-43.1c-.8-2-.2-4.3 1.5-5.7l17-13.9c2-1.6 4.8-1.5 6.6.3L224 341l26.5-25.6c1.8-1.8 4.7-1.9 6.6-.3l17 13.9c1.7 1.4 2.3 3.7 1.5 5.7l-17 43.1c-.6 1.5-1.9 2.7-3.6 3C254.7 381 254.4 381 254 381zM231.3 347.9l20.8 19.4 13-32.9-10.7-8.8L231.3 347.9zM183 334.5l13 32.9 20.8-19.4-23-22.2L183 334.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M223.8,457C223.8,457,223.8,457,223.8,457c-2.1-1-3.9-1.5-4.7-3.4l-46.8-118.7l9.3-3.7L223.8,438l42.5-106.9l9.3,3.7l-47.2,118.8C227.7,455.5,225.8,457,223.8,457z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M223.8,457C223.8,457,223.8,457,223.8,457c-2.1-1-3.9-1.5-4.7-3.4l-16.3-41.5c-0.3-0.8-0.4-1.7-0.3-2.6l4.9-35l-4-9.5c-0.8-1.9-0.3-4.2,1.2-5.6l16-15c1.9-1.8,4.9-1.8,6.8,0l16,15c1.5,1.4,2,3.7,1.2,5.6l-4,9.5l4.8,34.5c0.1,0.9,0,1.7-0.3,2.5l-16.7,42.1C227.7,455.5,225.8,457,223.8,457z M212.6,409.5l11.2,28.5l11.5-29l-4.8-34.5c-0.1-0.9,0-1.8,0.3-2.6l3.2-7.5l-10-9.4l-10,9.4l3.2,7.5c0.3,0.8,0.5,1.7,0.3,2.6L212.6,409.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M202 512c-1.1 0-2.2-.3-3.1-1-1.8-1.4-2.4-3.7-1.6-5.8l21.8-55.5 9.3 3.7L213 492.8l44.8-32.9 5.9 8.1L205 511C204.1 511.7 203 512 202 512zM275.6 437.3l-9.4-41.9c-.4-1.7.1-3.4 1.4-4.7 1.2-1.2 3-1.7 4.7-1.3l17.9 4.2V344h10v56c0 1.5-.7 3-1.9 3.9-1.2.9-2.8 1.3-4.3.9l-16.2-3.8 7.7 34.1L275.6 437.3z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M208.9 486L162 451.7c-1.6-1.2-2.4-3.2-1.9-5.1l10.2-45.5-16.2 3.8c-1.5.4-3.1 0-4.3-.9-1.2-.9-1.9-2.4-1.9-3.9v-56h10v49.7l17.9-4.2c1.7-.4 3.4.1 4.7 1.3 1.2 1.2 1.7 3 1.4 4.7l-11.3 50.1 44.2 32.4L208.9 486zM451 512h-20c-2.8 0-5-2.2-5-5 0-41.4-33.6-75-75-75s-75 33.6-75 75c0 2.8-2.2 5-5 5h-20c-2.8 0-5-2.2-5-5 0-57.9 47.1-105 105-105s105 47.1 105 105C456 509.8 453.8 512 451 512zM435.9 502h10c-2.6-50.1-44.2-90-94.9-90s-92.3 39.9-94.9 90h10c2.6-44.5 39.7-80 84.9-80S433.3 457.5 435.9 502z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M387,512h-72c-2.8,0-5-2.2-5-5v-36c0-2.8,2.2-5,5-5h72c2.8,0,5,2.2,5,5v36C392,509.8,389.8,512,387,512z M320,502h62v-26h-62V502z"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 29.1,
    x: 392.3,
    y: 446.2,
    transform: "rotate(45.004 397.256 460.69)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 29.1,
    height: 10,
    x: 290.2,
    y: 455.7,
    transform: "rotate(45.001 304.723 460.715)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 49.7,
    x: 399.6,
    y: 464.6,
    transform: "rotate(45.004 404.55 489.394)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 50.2,
    height: 10,
    x: 272.1,
    y: 484.2,
    transform: "rotate(45.001 297.25 489.242)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 67.4,
    height: 10,
    x: 57.8,
    y: 404.1,
    transform: "rotate(77.233 91.542 409.116)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M224.1,269c-20.9,0-29.4-13-31-19.9c-0.3-1.5,0-3,1-4.2c0.9-1.2,2.4-1.9,3.9-1.9h52c1.5,0,2.9,0.7,3.9,1.9c0.9,1.2,1.3,2.7,1,4.2C253.4,256,245,269,224.1,269z M206.7,253c3,3,8.3,6,17.4,6c9.1,0,14.3-3,17.3-6H206.7z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M240,313h-32c-0.8,0-1.7-0.2-2.4-0.6c-1.7-1-42.9-24-56.7-43.9c-20.3-29.3-24.7-95.4-24.9-98.2l10-0.6c0,0.7,4.4,66.1,23.1,93.1c11.3,16.3,45.6,36.4,52.2,40.2h29.3c6.9-4.1,42.1-25.9,52.3-40.2c19-26.8,23-92.4,23.1-93.1l10,0.6c-0.2,2.8-4.3,69.2-24.9,98.3c-12.5,17.6-54.7,42.7-56.5,43.7C241.8,312.8,240.9,313,240,313z"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 19.8,
    x: 249,
    y: 299.2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M392 413.7h-10v-1.2c0-13.5-7.9-26-20.2-31.7l-92.9-43.3 4.2-9.1 92.9 43.3c15.8 7.4 26 23.4 26 40.8V413.7zM251 512H61c-2.8 0-5-2.2-5-5v-94.5c0-17.4 10.2-33.4 26-40.8l92.7-43.2 4.2 9.1-92.7 43.2C73.9 386.5 66 398.9 66 412.5V502h185V512z"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 19.4,
    x: 189,
    y: 299.6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriver);
export default __webpack_public_path__ + "static/media/_driver.0bd59ca4406ca754dbcc758b86b3716e.svg";
export { ForwardRef as ReactComponent };